import dayjs from "dayjs";
import { statusTypes } from "../../mls-match-list/utils";
import { isFuture } from "date-fns";

const liveStatuses = [
  statusTypes.live,
  statusTypes.firstHalf,
  statusTypes.half,
  statusTypes.secondHalf,
  statusTypes.firstHalfExtra,
  statusTypes.halfExtra,
  statusTypes.secondHalfExtra,
  statusTypes.penalty,
  statusTypes.prePenalty
];

export function getNearestDate({ baseDate = dayjs(), dates }) {
  const nearest = dates?.reduce(
    (acc, current) => {
      const currentDate = dayjs(current.date);
      const currentDiff = getDateDifference(baseDate, currentDate);
      if (acc.diff > currentDiff) {
        return { date: current.date, diff: currentDiff };
      }

      return acc;
    },
    { date: null, diff: Number.MAX_SAFE_INTEGER }
  );

  return nearest?.date;
}

function getDateDifference(firstDate, secondDate) {
  return Math.abs(firstDate.diff(secondDate));
}

function isSameDay(firstDate, secondDate) {
  return dayjs(firstDate).isSame(dayjs(secondDate), "day");
}

function getActiveMatch(matches) {
  const activeMatch = matches.find(
    (match) => liveStatuses.includes(match?.status?.abbreviation)
  );

  if (activeMatch) {
    return activeMatch;
  }

  const nextMatch = matches.find((match) => {
    return isFuture(dayjs(match?.planned_kickoff_time).toDate());
  });

  return nextMatch || matches[0];
}

export function getMatchesByDate(matches, date) {
  return matches.find((matches) => {
    return isSameDay(matches.date, date);
  });
}

export function getNearestMatch(matches, date) {
  const isNearestBeforeToday = dayjs(date).isBefore(dayjs());

  if (isNearestBeforeToday) {
    return matches[matches.length - 1];
  } else {
    return matches[0];
  }
}

export function getTodaysNearestMatch(matches) {
  let activeMatch = null;

  matches?.forEach((matches) => {
    const today = isSameDay(dayjs(), matches?.date);

    if (today && matches.matches?.length) {
      activeMatch = getActiveMatch(matches.matches);
    }
  });

  return activeMatch;
}
